import {ReactNode} from 'react';
import {Routes} from '../../constants/routes';
import {Permission} from 'utils/hooks/permissions/usePermissions';

export const makeSideMenuItem = (
    label: string,
    route: string,
    icon: ReactNode,
    requiredPermission?: Permission,
) => ({
    label,
    icon,
    route: `${Routes.Administration}${route}`,
    requiredPermission,
});

export const makeAdminRoutes = (path: Routes, element: ReactNode) => ({
    key: path,
    path: `${Routes.Administration}${path}`,
    element,
});
